import script from "./OutsideBuildingView.vue?vue&type=script&setup=true&lang=js"
export * from "./OutsideBuildingView.vue?vue&type=script&setup=true&lang=js"

import "./OutsideBuildingView.vue?vue&type=style&index=0&id=1b674ade&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1b674ade"]])

export default __exports__